import { createBuilderModule } from '../../../register-builder/builder-module';
import { SectionName, withTracking } from '../../../observability';
import { AppsSection } from './AppsSection';
import { DEFAULT_VALUES } from './fixtures';

export default createBuilderModule(
  withTracking(AppsSection, {
    as: 'section',
    sectionName: SectionName.AppsSection,
  }),
  {
    name: 'AppsSection',
    image: 'https://cdn.zappy.app/17572733d9a5c08c7a4862e4ee712358.png',
    inputs: [
      {
        name: 'heading',
        type: 'richText',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'body',
        type: 'richText',
        required: true,
        defaultValue: DEFAULT_VALUES.body,
      },
      {
        name: 'ctaText',
        type: 'string',
        defaultValue: DEFAULT_VALUES.ctaText,
      },
      {
        name: 'ctaUrl',
        type: 'string',
        defaultValue: DEFAULT_VALUES.ctaUrl,
      },
      {
        name: 'apps',
        type: 'list',
        required: true,
        defaultValue: DEFAULT_VALUES.apps,
        subFields: [
          {
            name: 'name',
            type: 'string',
            required: true,
          },
          {
            name: 'iconUrl',
            type: 'cloudinaryImage',
            required: true,
          },
          {
            name: 'appProfileUrl',
            type: 'string',
            required: true,
          },
        ],
      },
    ],
  },
);
